<template>
    <base-spinner v-if="loading" />
    <div v-else>
      <div>
        <div>
          <b-alert :show="error && error.length ? true : false" variant="danger">
            <div v-if="Array.isArray(error)">
              <div
                class="d-flex flex-column my-1"
                v-for="(error_text, index) in error"
                :key="index"
              >
                {{ error_text }}
              </div>
            </div>
            <div v-else>
              <div v-html="error || '&nbsp;'"></div>
            </div>
          </b-alert>
          <div class="col-12">
            <b-table
              :items="items"
              :fields="fields"
              :hover="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :per-page="perPage"
              :current-page="1"
              label-sort-asc=""
              label-sort-desc=""
              label-sort-clear=""
              sort-icon-right
              show-empty
              :no-border-collapse="true"
              responsive="lg"
              thead-class="table-thead text-center bg-transparent "
              tbody-class="table-tbody text-center cursor-pointer"
              ref="selectableTable"
              info="true"
              class="new-theme-custom-table"
              id="transaction_log_table"
              @row-clicked="(transaction) => showTransactionDetails(transaction)"
            >
              <template #empty> {{ $t("empty-row") }} </template>
              <template #cell(username)="{ item }"
                >{{ item?.user?.userName ?? "---" }}
              </template>
              <template #cell(createdAt)="{ item }">
                {{ formatDate(item?.createdAt) }}
              </template>
              <template #cell(branch)="{ item }">
                <span>{{
                  $store.getters["enums/branch_enums"]?.find(
                    (each) => each.value && each.value === item?.user?.branch
                  )?.text || "---"
                }}</span>
              </template>
              <template #cell(role)="{ item }">
                <span>{{
                  $store.getters['enums/roles_enums']?.find(
                    (each) => each.value && each.value === item?.user?.role
                  )?.text || "---"
                }}</span>
              </template>
              <template #cell(entityID)="{ item }">
                <span>{{ item?.collectionId || "---" }}</span>
              </template>
            </b-table>
            <b-pagination
              v-if="total"
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              aria-controls="my-table"
              class="d-flex justify-content-end"
              :first-number="false"
              :last-number="false"
              hide-goto-end-buttons
              ></b-pagination>
          </div>
        </div>
      </div>
      <b-sidebar
        :visible="isDetailsShown"
        id="transaction-detail-sidebar-backdrop"
        bg-variant="white"
        backdrop
        :right="!isLangRtl"
        shadow
        width="70%"
        @hidden="hideTransactionDetails"
      >
        <TransactionDetails
          v-if="isDetailsShown"
          :transactionData="selectedTransaction"
        />
      </b-sidebar>
    </div>
  </template>
  
  <script>
  import TransactionDetails from "../Listing/TransactionDetails/TransactionDetails.vue";
  import moment from "moment";
  import HistoryService from "@/services/history.service";
  
  export default {
    components: {
      TransactionDetails,
    },
    props: ["filterBy"],
    data() {
      return {
        filterBtnHovered: false,
        variant: "transparent",
        loading: false,
        error: null,
        search_term: "",
        sortBy: "",
        sortDesc: false,
        perPage: 10,
        currentPage: 1,
        total: 0,
        fields: [
          {
            key: "username",
            label: this.$t("username"),
            sortable: false,
          },
          {
            key: "role",
            label: this.$t("role"),
            sortable: false,
          },
          {
            key: "branch",
            label: this.$t("branch"),
            sortable: false,
          },
          {
            key: "modelName",
            label: this.$t("entity"),
            sortable: false,
          },
          {
            key: "entityID",
            label: this.$t("entity-id"),
            sortable: false,
          },
          {
            key: "op",
            label: this.$t("action"),
            sortable: false,
          },
          {
            key: "createdAt",
            label: this.$t("date"),
            sortable: false,
          },
        ],
        items: [],
        isDetailsShown: null,
        selectedTransaction: null,
        helper_text: null,
      };
    },
    methods: {
      formatDate(date) {
        return moment(date).locale("en").format("DD-MM-YYYY HH:mm");
      },
      async getData() {
        this.loading = true;
        this.error = null;
        this.total = 0;
        this.items = [];

        let params = new URLSearchParams();
  
        params.append("page", this.currentPage);
        params.append("limit", this.perPage);
        params.append("sort", "-updatedAt");
  
        if (this.filterBy?.type)
          params.append("modelName", this.filterBy.type);
        if (this.filterBy?.id)
          params.append("collectionId", this.filterBy.id);
  
        HistoryService.search(params)
          .then(({ items, total }) => {
            this.items = items;
            this.total = 999999999999999;
          })
          .catch(({ message }) => {
            this.error = message;
          })
          .finally(() => {
            this.loading = false;
          });
      },
      showTransactionDetails(transaction) {
        this.isDetailsShown = true;
        this.selectedTransaction = transaction;
      },
      hideTransactionDetails() {
        this.isDetailsShown = false;
        this.selectedTransaction = null;
      },
    },
    watch: {
      currentPage(val) {
        if (val) this.getData();
      },
    },
    created() {
      this.$store.dispatch("enums/GET_BRANCH_ENUMS");
      this.$store.dispatch("enums/GET_USERNAME_ENUMS");
      this.$store.dispatch("enums/GET_ROLES_ENUMS");
    },
    mounted() {
      this.getData();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .title {
    font-weight: 700;
    font-size: 18px;
    color: var(--color-17);
  }
  .helper-text {
    color: var(--color-47);
  }
  </style>
  <style lang="scss">
  input[type="date" i] i {
    cursor: pointer;
    color: var(--color-49);
  }
  </style>
  